import React from "react";
import { Navigate } from "react-router-dom";

import authService from "../services/authService";

import SuperAdminReports from "./Reports/SuperAdminReports";
import DealerReports from "./Reports/DealerReports";
import ShopReports from "./Reports/ShopReports";

const Reports = () => {
  const user = authService.getCurrentUser();

  switch (user?.role) {
    case "SUPER_ADMIN":
      return <SuperAdminReports />;

    case "DEALER":
      return <DealerReports />;

    case "SHOP":
      return <ShopReports />;

    case "PLAYER":
      return <Navigate to="/wallet-history" replace />;

    default:
      return <Navigate to="/login" replace />;
  }
};

export default Reports;